module.exports = __webpack_public_path__ + "static/flags/KT-b5c3718ae30e19529b07584d6e3b498b.gif";